<template>
  <div class="order-wrap">
    <van-list
      v-model="loading"
      :finished="finished"
      :immediate-check="false"
      finished-text=""
      @load="onLoad"
    >
      <div class="desc">仅展示最近1年订单</div>
      <div class="lists-box">
        <div
          class="list-item"
          :class="{ active: item.status > 0 }"
          v-for="item in lists"
          :key="item.order_id"
          @click="toDetail(item)"
        >
          <div class="list-t">
            <div class="list-t-l">{{ item.title }}</div>
            <div class="list-t-r">
              {{ item.fee }}<label class="ex">元</label>
            </div>
          </div>
          <div class="list-b">
            <div class="list-b-l">{{ item.pay_time }}</div>
            <div
              class="list-b-r"
              :class="{ active: item.status === 1 }"
              v-if="item.status > 0"
            >
              {{ statusLists[item.status] }}
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <div class="see-end" v-if="lists.length && nomore">
        已经到最底部啦
    </div>
    <div class="see-end" v-if="!lists.length">暂无订单信息</div>
  </div>
</template>
<script>
import questionOnly from "@/utils/questionOnly";
import { Toast } from "vant";
import { reLogin, getToken } from "../../utils/common";
export default {
  data() {
    return {
      statusLists: ["", "待处理", "处理中", "已结束", ""],
      refreshing: false,
      loading: false,
      finished: true,
      pageSize: 20,
      page: 1,
      lists: [],
      total: 0,
      nomore: false
    };
  },
  methods: {
    toDetail(e) {
      let { order_id, status } = e;
      let urlName = status != 0 && status != 4 ? "complainlist" : "orderdetail"; // 去到投诉列表 || 去到订单详情
      this.$router.push({
        name: urlName,
        query: {
          no: order_id
        }
      });
    },
    getDetail(page = 1) {
      this.page = page;
      let param = {
        access_token: getToken(),
        count: this.pageSize,
        page: this.page
      };
      questionOnly.get("/xcx/ques/v1/order/list", param).then(res => {
        this.loading = false;
        this.refreshing = false;
        if (res.sta == 0) {
          let r = res.data;
          if (!r.lists.length) {
            this.finished = true;
            this.nomore = true;
          } else {
            this.finished = false;
          }
          this.lists = this.lists.concat(r.lists);
          this.total = r.total;
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    },
    onLoad() {
      this.getDetail(this.page + 1);
    }
  },
  mounted() {
    document.title = "我的订单";
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.order-wrap {
  padding: 20px 15px 0;
  padding-bottom: env(safe-area-inset-bottom);
  max-width: 500px;
  min-width: 320px;
  position: relative;
  min-height: 100vh;
  margin: 0 auto;
  box-sizing: border-box;
}
.desc {
  font-size: 13px;
  margin-bottom: 10px;
  color: #999999;
}
.list-item {
  margin-bottom: 10px;
  padding: 10px 15px;
  background: #ffffff;
  border-radius: 4px;
}
.list-t {
  margin-bottom: 10px;
}
.list-t,
.list-b {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.list-t-l {
  font-size: 15px;
}
.list-t-r {
  font-size: 15px;
  font-weight: bold;
}
.list-t-r .ex {
  font-size: 13px;
  font-weight: initial;
}
.list-b-l {
  font-size: 13px;
  color: #999999;
}
.list-b-r {
  font-size: 13px;
  color: #999999;
}
.list-b-r.active {
  color: #ff0000;
}
.see-end {
  color: #999999;
  font-size: 13px;
  text-align: center;
  padding: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/order/orderlist.vue